(() => {
  const productInfo = document.querySelector('product-info.relin-luna-product');
  if (!productInfo || productInfo.dataset.relinConversionReady === 'true') return;

  window.__relinLunaConversionCleanup?.();
  productInfo.dataset.relinConversionReady = 'true';

  const listenerController = new AbortController();
  let paymentIconsObserver;

  const cleanup = () => {
    listenerController.abort();
    paymentIconsObserver?.disconnect();
    if (window.__relinLunaConversionCleanup === cleanup) delete window.__relinLunaConversionCleanup;
  };

  window.__relinLunaConversionCleanup = cleanup;

  const parseJson = (selector) => {
    try {
      return JSON.parse(productInfo.querySelector(selector)?.textContent || 'null');
    } catch {
      return null;
    }
  };

  const variants = parseJson('[data-relin-variant-data]') || [];
  const savings = productInfo.querySelector('[data-relin-savings]');
  const urgency = productInfo.querySelector('[data-relin-urgency]');
  const productForm = productInfo.querySelector('product-form');
  const currencyCode = productInfo.querySelector('variant-selects')?.dataset.currencyCode || 'EUR';

  const placePaymentIcons = () => {
    const paymentIcons = productInfo.querySelector('.relin-payment-icons');
    const productFormButtons = productInfo.querySelector('.product-form__buttons');
    if (!paymentIcons || !productFormButtons) return;

    const easySellButton = productFormButtons.querySelector('.es-popup-button-product');
    if (easySellButton) {
      if (paymentIcons.nextElementSibling !== easySellButton) {
        productFormButtons.insertBefore(paymentIcons, easySellButton);
      }
      return;
    }

    if (paymentIcons.parentElement !== productFormButtons) {
      productFormButtons.append(paymentIcons);
    }
  };

  placePaymentIcons();
  paymentIconsObserver = new MutationObserver(placePaymentIcons);
  paymentIconsObserver.observe(productInfo, { childList: true, subtree: true });

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, savings?.dataset.moneyFormat || undefined);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
      style: 'currency',
      currency: currencyCode,
    }).format(cents / 100);
  };

  const updateSavings = (variant) => {
    if (!savings) return;
    const price = Number(variant?.price);
    const compareAtPrice = Number(variant?.compare_at_price);
    const amount = compareAtPrice - price;
    const shouldShow =
      Boolean(variant?.available) &&
      Number.isFinite(price) &&
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > 0 &&
      compareAtPrice > price;
    savings.textContent = shouldShow ? `Risparmi ${formatMoney(amount)}` : '';
    savings.classList.toggle('hidden', !shouldShow);
  };

  const updateUrgency = (variant) => {
    if (!urgency) return;
    const quantity = Number(variant?.inventory_quantity);
    const hasExactSignal =
      Boolean(variant?.available) &&
      variant?.inventory_management === 'shopify' &&
      variant?.inventory_policy !== 'continue' &&
      Number.isFinite(quantity) &&
      quantity > 0;

    if (!hasExactSignal || quantity > 3) {
      urgency.hidden = true;
      urgency.textContent = '';
      return;
    }

    urgency.textContent = quantity === 1
      ? 'Ultimo articolo disponibile per questa variante'
      : `Solo ${quantity} disponibili per questa variante`;
    urgency.hidden = false;
  };

  const getAuthoritativeVariant = (fallbackVariant) => {
    const selectedVariantId = productForm?.querySelector('input[name="id"]')?.value;
    if (!selectedVariantId) return productForm ? null : fallbackVariant;
    return variants.find((variant) => String(variant.id) === String(selectedVariantId)) || null;
  };

  const updateVariantState = (variant, available = Boolean(variant?.available)) => {
    const selectedVariant = getAuthoritativeVariant(variant);
    const exactVariant = selectedVariant || (productForm ? null : variant);
    const isAvailable = available && Boolean(exactVariant?.available);
    updateSavings(isAvailable ? exactVariant : null);
    updateUrgency(isAvailable ? exactVariant : null);
  };

  productInfo.addEventListener('relin:variant-change', (event) => {
    updateVariantState(event.detail?.variant || null, event.detail?.available !== false);
  }, { signal: listenerController.signal });

  const initialVariant = parseJson('variant-selects [data-selected-variant]') || variants.find((variant) => variant.available) || variants[0] || null;
  updateVariantState(initialVariant, Boolean(initialVariant?.available));
})();
